import React from 'react';
import { Alert } from '../..';
import SelectBase from './SelectBase';
import { api } from '../../../config/Services';
import { RetrieveRequest } from '../../../utilities/services/RequestService';

class CategoryCodeSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            isLoading: false
        }
    }

    retrieveData(criteria = {}) {
        let paging = { limit: -1, page: 1 }
        let sort = { categorycode: 'asc' };
        let url = api.url.awardtype.category;
        let column = [];
        this.setState({ isLoading: true });
        RetrieveRequest(url, criteria, sort, paging, column).then((response) => {
            const { status = {} } = response || {};
            if (status.responsecode === '0000') {
                var options = response.result.map(({ categorycode }) => {
                    return {
                        label: categorycode,
                        value: categorycode
                    };
                });
                
                this.setState({ options, isLoading: false });
            } else {
                Alert.error(response.status.responsemessage);
            }
        });
    }

    render() {
        return (<SelectBase {...this.props} options={this.state.options} isLoading={this.state.isLoading} />)
    }

}

export default CategoryCodeSelect;